import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CommonSelect from "../../../core/common/commonSelect";
import {
  DueDate,
  feeGroup,
  feesTypes,
  fineType,
  ids,
  status,
} from "../../../core/common/selectoption/selectoption";
import Table from "../../../core/common/dataTable/index";
import FeesModal from "./feesModal";
import { feesMasterData } from "../../../core/data/json/feesMaster";
import TooltipOption from "../../../core/common/tooltipOption";
import { getUser } from "../../network/auth/Auth";
import UserService from "../../network/services/UserService";
import { Modal, Toast } from "react-bootstrap";

const FeesMaster = () => {
  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const data = feesMasterData;
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const selectionTerm = [
    { value: "fixed_days", label: "Fixed Fees of Days" },
    { value: "fixed_date", label: "Fixed Fees of Dates" },

  ];


  interface FeesTermData {
    id: any;
    name: any;
    fees_terms: any;
    note: any;
    active: any;
    no_days: any;
    day_type: any;
    discount: any;
    operating_branch_id: any;
    company_id: any;
  }
  interface Option {
    id: any;
    name: any;
  }

  const [feesTerms, setFeesTerms] = useState<FeesTermData[]>([]);
  const [branch, setBranch] = useState<any>();
  const branches = getUser()?.company_ids[0]?.branches;
  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);



  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);


  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    fees_terms: '',
    discount: '',
    operating_branch_id: '',
    company_id: '',
    note: '',
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    fees_terms: '',
    discount: '',
    operating_branch_id: '',
    company_id: '',
    note: '',
  });



  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };


  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    console.log(record)
    console.log(record?.operating_branch_id[0]?.id)
  };



  const handleSubmit = () => {
    setIsLoading(true)
    const request_data = {
      name: formData.name,
      note: formData.note,
      discount: parseFloat(formData.discount),
      fees_terms: formData.fees_terms === "" ? selectionTerm[0].value : formData.fees_terms,
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: formData.operating_branch_id === "" ? getUser()?.company_ids[0]?.branches[0]?.id : parseInt(formData.operating_branch_id, 10),
    };

    UserService.addFeesTerm(request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessful(true)
        setSuccessMessage('Data saved successfully')
        setShowSuccessToast(true)
        setFormData({
          name: '',
          fees_terms: '',
          discount: '',
          operating_branch_id: '',
          company_id: '',
          note: '',
        });

        setShowModal(false);

      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const handleSubmitEdit = () => {
    setIsLoading(true)
    const request_data = {
      name: selectedRecord?.name,
      note: selectedRecord?.note,
      discount: selectedRecord?.discount,
      fees_terms: selectedRecord?.fees_terms === "" ? selectionTerm[0].value : selectedRecord?.fees_terms,
      company_id: getUser()?.company_ids[0]?.id,
      operating_branch_id: selectedRecord?.operating_branch_id?.[0]?.id === undefined ? parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10) : parseInt(selectedRecord?.operating_branch_id?.[0]?.id, 10),
    };


    UserService.editFeesTerm(selectedRecord?.id, request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.branches[0]?.id, getUser()?.company_ids[0]?.id, branch);
        setIsLoading(false)
        setIsActionSuccessfulEdit(true)

        setFormData({
          name: '',
          fees_terms: '',
          discount: '',
          operating_branch_id: '',
          company_id: '',
          note: '',
        });
        handleClose2()
      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };




  const fetchData = async (branch_id: any, company_id: any, item: any) => {
    if (item) {
      setBranch(item.name);
    }
    UserService.getFeesTermByBranchAndComapny(branch_id, company_id, (response: any) => {
      if (response?.data && response?.success) {
        setFeesTerms(response.data);

      } else {
        setFeesTerms([]);
      }
    });
  };

  const fetchDataInit = async (company_id: any) => {
    setBranch('All');
    UserService.getFeesTermByBranchAndComapnyAll(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setFeesTerms(response.data);

      } else {
        setFeesTerms([]);
      }
    });
  };

  useEffect(() => {
    fetchDataInit(getUser()?.company_ids[0]?.id);

  }, []);









  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string) => (
        <Link to="#" className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: FeesTermData, b: FeesTermData) => a.id.length - b.id.length,
    },
    {
      title: "Fees Name",
      dataIndex: "name",
      sorter: (a: FeesTermData, b: FeesTermData) =>
        a.name.length - b.name.length,
    },

    {
      title: "Fees Term",
      dataIndex: "fees_terms",
      sorter: (a: FeesTermData, b: FeesTermData) =>
        a.fees_terms.length - b.fees_terms.length,
    },
    {
      title: "Note",
      dataIndex: "note",
      sorter: (a: FeesTermData, b: FeesTermData) =>
        a.note.length - b.note.length,
    },
    {
      title: "Company",
      dataIndex: "company_id",
      render: (record: any) => (
        <>
          {record && record?.map((item: any, index: any) =>
            (<span>{item.name}</span>)
          )}
        </>
      ),
      sorter: (a: FeesTermData, b: FeesTermData) =>
        (a.company_id?.length || 0) - (b.company_id?.length || 0),
    },

    {
      title: "Branch",
      dataIndex: "operating_branch_id",
      render: (record: any) => (
        <>
          {record && record?.map((item: any, index: any) =>
            (<span>{item.name}</span>)
          )}
        </>
      ),
      sorter: (a: FeesTermData, b: FeesTermData) =>
        a.operating_branch_id.length - b.operating_branch_id.length,
    },


    {
      title: "Status",
      dataIndex: "active",
      render: (rec: any) => (
        <>
          {rec ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Active
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Inactive
            </span>
          )}
        </>
      ),
      sorter: (a: FeesTermData, b: FeesTermData) => a.active.length - b.active.length,
    },
    {
      title: "Action",

      render: (record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => handleEdit(record)}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Fees Terms</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Fees </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Fees Terms
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              {getUser().role === "school_admin" && (<div className="mb-2">
                <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Fees Master
                </Link>

              </div>)}

            </div>
          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Fees Terms</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">ID</label>
                              <CommonSelect
                                className="select"
                                options={ids}
                                defaultValue={ids[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Fees Group</label>
                              <CommonSelect
                                className="select"
                                options={feeGroup}
                                defaultValue={feeGroup[0]}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Fees Type</label>
                              <CommonSelect
                                className="select"
                                options={feesTypes}
                                defaultValue={feesTypes[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Due Date</label>
                              <CommonSelect
                                className="select"
                                options={DueDate}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Fine Type</label>
                              <CommonSelect
                                className="select"
                                options={fineType}
                                defaultValue={undefined}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-0">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li >
                      <a className="dropdown-item rounded-1" onClick={() => fetchDataInit(getUser()?.company_ids[0]?.id)}>
                        All
                      </a>
                    </li>
                    {branches?.map((item: any) => (
                      <li key={item.id}>
                        <a className="dropdown-item rounded-1" onClick={() => fetchData(item.id, getUser()?.company_ids[0]?.id, item)}>
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              {<Table dataSource={feesTerms} columns={columns} Selection={true} />}
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <FeesModal />


      <Modal show={showModal} onHide={handleClose} >
        <Modal.Header >
          <Modal.Title>Add Fees</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                      onChange={handleInputChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Discount</label>
                    <input type="number" className="form-control" name="discount"
                      value={formData.discount}
                      onChange={handleInputChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input type="text" className="form-control" name="note"
                      value={formData.note}
                      onChange={handleInputChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Term Structure</label>
                    <select

                      className="select react-select form-control"
                      name="fees_terms"
                      onChange={handleInputChange}
                    >
                      <option >Select Fees Terms</option>
                      {selectionTerm && selectionTerm?.map((item: any) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}

                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select

                      className="select react-select form-control"
                      name="operating_branch_id"
                      onChange={handleInputChange}
                    >
                      <option >Select Branch</option>
                      {branches && branches?.map((item: any) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}

                    </select>
                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary" onClick={handleSubmit}  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Add Fees"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Modal show={showModal2} onHide={handleClose2} >
        <Modal.Header >
          <Modal.Title>Edit Fees</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose2}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord.name}
                      onChange={handleInputChangeEdite} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Discount</label>
                    <input type="number" className="form-control" name="discount"
                      value={selectedRecord.discount}
                      onChange={handleInputChangeEdite} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input type="text" className="form-control" name="note"
                      value={selectedRecord.note}
                      onChange={handleInputChangeEdite} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Term Structure</label>
                    <select

                      className="select react-select form-control"
                      name="fees_terms"
                      value={selectedRecord?.fees_terms || ''}
                      onChange={handleInputChangeEdite}
                    >
                      {selectionTerm && selectionTerm?.map((item: any) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}

                    </select>
                  </div>


                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select
                      className="select react-select form-control"
                      name="operating_branch_id"
                      value={selectedRecord?.operating_branch_id?.[0]?.id || ''}// Assurez-vous que cette valeur correspond à une option
                      onChange={handleInputChangeEdite2}
                    >
                      {branches && branches.map((item: any) => (
                        <option value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>

                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose2}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary" onClick={handleSubmitEdit}  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Edit Fees"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Toast
        show={showDangerToast}
        onClose={handleDangerToastClose}
        id="dangerToast"
        className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: "200px!important" }}
      >
        <Toast.Header closeButton className="bg-danger text-fixed-white">
          <strong className="me-auto">Message</strong>
          <span
            className="cursor-pointer"
            onClick={handleDangerToastClose}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          />
        </Toast.Header>
        <Toast.Body>
          {/* Add your toast content here */}
          {errorMessage}
        </Toast.Body>
      </Toast>

      <Toast
        show={showSuccessToast}
        onClose={handleSuccessToastClose}
        id="successToast"
        className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >

        <Toast.Body>
          {/* Add your toast content here */}
          {successMessage}
        </Toast.Body>
      </Toast>
    </>
  );
};

export default FeesMaster;
